<template>
    <ul class="product-accordion" data-accordion>
        <li class="accordion__item" data-accordion-item ref="accordion">
            <a
                class="block w-full is-active py-6 px-6 lg:py-12 lg:px-10"
                href="javascript:;"
                data-accordion-link
            >
                <h3 class="h3 accordion-filter-btn text-offBlack pr-10">
                    {{ category.title }}
                </h3>
            </a>

            <div
                class="accordion__content-products is-active"
                data-accordion-content
            >
                <div class="swiper-container swiper-products w-full">
                    <div :class="getWrapperClass">
                        <div
                            v-for="model in category.models"
                            :key="model.id"
                            class="swiper-slide"
                        >
                            <product :model="model"></product>
                        </div>

                        <!-- <div class="swiper-slide">
                        <div class="product-module">
                            <div class="product-module__wrapper-no-hover no-results">
                                <h4 class="h4">No results <br>found</h4>
                            </div>
                        </div>
                    </div> -->

                        <div class="swiper-slide">
                            <div class="product-module">
                                <a
                                    class="product-module__wrapper view-all"
                                    :href="category.uri"
                                >
                                    <span class="text-base lg:text-lg"
                                        >View all</span
                                    >
                                    <h4 class="h4">{{ category.title }}</h4>
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fal"
                                        data-icon="long-arrow-right"
                                        class="w-7 mt-10 svg-inline--fa fa-long-arrow-right fa-w-14"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 448 512"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M311.03 131.515l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887l-83.928 83.444c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l116.485-116c4.686-4.686 4.686-12.284 0-16.971L328 131.515c-4.686-4.687-12.284-4.687-16.97 0z"
                                        ></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
import Product from "./Product";
import { onMounted, ref, computed } from "vue";
import { toggleAccordion, bindEvent } from "../../js/accordion";

export default {
    props: {
        category: Object,
    },
    components: {
        Product,
    },
    setup() {
        const accordion = ref(null);
        const getWrapperClass = computed(() => {
            const screenSize = window.innerWidth;
            if (screenSize >= 1024) {
                return "flex flex-wrap";
            } else {
                return "swiper-wrapper";
            }
        });
        onMounted(() => {
            const accordionLink = accordion.value.firstElementChild;
            bindEvent(accordionLink, "click", toggleAccordion);
        });

        return { accordion, getWrapperClass };
    },
};
</script>
